import {createContext, useState} from 'react'

import PropTypes from 'prop-types'

import LoginModal from '@adv-mt/mt-login-modal'

export default function ContextLoginModal() {
  return <div>Must use context & provider named exports</div>
}

const defaultContextValue = {triggerLoginModal: () => {}}

export const LoginModalContext = createContext(defaultContextValue)

export const LoginModalProvider = ({children}) => {
  const [loginModalProps, setLoginModalProps] = useState({})
  const {isOpen} = loginModalProps

  const closeModal = () => setLoginModalProps({isOpen: false})

  const triggerLoginModal = ({modalProps}) => {
    const {onClose: onCloseFromProps, onLogin: onLoginFromProps} = modalProps
    setLoginModalProps({
      ...modalProps,
      isOpen: true,
      onClose: () => {
        closeModal()
        onCloseFromProps && onCloseFromProps()
      },
      onLogin: (...args) => {
        closeModal()
        onLoginFromProps && onLoginFromProps(...args)
      }
    })
  }

  return (
    <LoginModalContext.Provider value={{triggerLoginModal, isLoginModalOpen: isOpen}}>
      {children}
      {isOpen && <LoginModal {...loginModalProps} />}
    </LoginModalContext.Provider>
  )
}

LoginModalProvider.propTypes = {
  children: PropTypes.any
}

ContextLoginModal.displayName = 'ContextLoginModal'
ContextLoginModal.propTypes = {}
